// import { useCallback } from 'react'
import { styled } from '@mui/material/styles'
// import { useSelector, useDispatch } from 'react-redux'
import './filledCircleSequence.css'
import Tooltip from '@mui/material/Tooltip'
const Root = styled('div')(({ theme, x, y }) => ({
  zIndex: 102,
  left: x,
  top: y,
  width: 67,
  height: 67,
  backgroundColor: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer'
}))

const FilledCircleSequenceHotspot = ({ x, y, onClick }) => {
  return (
    <Tooltip title="Cadena de texto">
      <Root x={x} y={y} onClick={onClick}>
        <div
          style={{
            backgroundImage: `url('${process.env.PUBLIC_URL}/images/hotspot_sequence_filled_circle.png')`
          }}
          className="filled-circle-sequence"
        ></div>
      </Root>
    </Tooltip>
  )
}
export default FilledCircleSequenceHotspot
